import useVerify from "../hooks/use-verify";

export default function Setup() {
  useVerify();

  return null;
}
